import { render } from "./ChangePass.vue?vue&type=template&id=49abfd60&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"

import "./ChangePass.vue?vue&type=style&index=0&id=49abfd60&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-49abfd60"

export default script